export const UNENROLLMENT_TX_STATUS = {
  PENDING_SIGNATURES: "PENDING_SIGNATURES",
  READY_TO_SUBMIT: "READY_TO_SUBMIT",
  SUBMITTED: "SUBMITTED",
  CONFIRMED: "CONFIRMED",
  FAILED: "FAILED",
  EXPIRED: "EXPIRED",
  CANCELLED: "CANCELLED",
} as const;

export type MultisigUnenrollmentTxStatus =
  (typeof UNENROLLMENT_TX_STATUS)[keyof typeof UNENROLLMENT_TX_STATUS];

export const ACTIVE_UNENROLLMENT_STATUSES: ReadonlyArray<MultisigUnenrollmentTxStatus> = [
  UNENROLLMENT_TX_STATUS.PENDING_SIGNATURES,
  UNENROLLMENT_TX_STATUS.READY_TO_SUBMIT,
  UNENROLLMENT_TX_STATUS.SUBMITTED,
];

export const TERMINAL_UNENROLLMENT_STATUSES: ReadonlyArray<MultisigUnenrollmentTxStatus> = [
  UNENROLLMENT_TX_STATUS.CONFIRMED,
  UNENROLLMENT_TX_STATUS.FAILED,
  UNENROLLMENT_TX_STATUS.EXPIRED,
  UNENROLLMENT_TX_STATUS.CANCELLED,
];

export const UNENROLLMENT_REQUIRED_SIGNATURES = 2;
